



















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Player } from "@/services/players/types";
import { Option } from "@/services/common/types";
import { getPlayers } from "@/services/players/playerService";
import { selectPlayersFields } from "@/components/players/fields/selectPlayersFields";
import i18n from "@/i18n";
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
import { Folder, FolderEntites } from "@/services/folders/types";

@Component({
    components: { FolderTree, vSelect }
})
export default class SelectPlayersModal extends Vue {
    players = [] as Player[];
    fields = selectPlayersFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;
    selectedPlayers = [] as Player[];
    showUnselectedPlayersOnly = false as boolean;
    alreadySelectedPlayerIds = [] as string[];
    selectedPlayerStatus = null as Option | any;

    // folders
    folderEntity = FolderEntites.Players;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    playerStatus = [
        {
            id: "true",
            text: i18n.t("player.filterSelectActive")
        },
        {
            id: "false",
            text: i18n.t("player.filterSelectInactive")
        }
    ] as Array<Option>;

    multiPicker = false;
    // filter options
    searchQuery = "";

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }

    // computed
    get filteredData() {
        let localPlayers = this.players;

        if (this.showUnselectedPlayersOnly && this.alreadySelectedPlayerIds) {
            localPlayers = localPlayers.filter(x => !this.alreadySelectedPlayerIds.some(y => y === x.id));
        }

        if (this.filterActive) {
            return localPlayers && localPlayers
                .filter(x => (this.searchQuery.length === 0 || x.name.toLowerCase().includes(this.searchQuery.toLowerCase())) &&
                    (this.selectedPlayerStatus ? x.status.toString() === this.selectedPlayerStatus.id : true));
        } else {
            if (this.showFolderTree) {
                // If the folder tree is visible, return only players in the selected folder
                return localPlayers.filter(
                    x => this.selectedFolderNode.id ? x.folderId === this.selectedFolderNode.id : true
                );
            } else {
                // If the folder tree is hidden, return all players
                return localPlayers;
            }
        }
    }

    get title(): string {
        return i18n.t("playerMonitors.selectPlayers").toString();
    }

    // methods
    fetchData() {
        this.isBusy = true;
        getPlayers().then(response => {
            this.players = response;
            this.isBusy = false;
        });
    }

    rowSelected(items: Player[]) {
        this.selectedPlayers = items;
    }

    open(alreadySelectedPlayerIds: string[], multiPicker = false) {
        this.multiPicker = multiPicker;
        this.alreadySelectedPlayerIds = alreadySelectedPlayerIds;
        this.fetchData();
        this.$bvModal.show("modal-selectPlayer");
    }

    save() {
        this.$bvModal.hide("modal-selectPlayer");
        if (!this.selectedPlayers || this.selectedPlayers.length === 0) {
            return;
        }

        this.$emit("select", this.selectedPlayers);
    }

    close() {
        this.$bvModal.hide("modal-selectPlayer");
    }

    resetState() {
        this.searchQuery = "";
        this.selectedPlayers = [] as Player[];
    }

    clearFilter() {
        this.selectedPlayerStatus = null;
    }

    select(value: boolean) {
        if (value) {
            this.$nextTick(() => {
                // Filter out already selected players
                const playersToSelect = this.filteredData.filter(player =>
                    !this.selectedPlayers.some(selectedPlayer => selectedPlayer.id === player.id)
                );

                playersToSelect.forEach(player => {
                    const elem = document.getElementById(`playersTable__row_${player.id}`);
                    if (elem !== null) elem.click();
                });
            });
        } else {
            this.$nextTick(() => {
                this.selectedPlayers.forEach(player => {
                    const elem = document.getElementById(`playersTable__row_${player.id}`);
                    if (elem !== null) elem.click();
                });
            });
        }
    }

    setSelectedFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    get filterActive(): boolean {
        return (
            (this.selectedPlayerStatus && Object.keys(this.selectedPlayerStatus.id).length > 0) ||
            this.searchQuery !== "");
    }
}
